import { render } from "./RulesPage.vue?vue&type=template&id=73ab8afe&scoped=true"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"

import "./RulesPage.vue?vue&type=style&index=0&id=73ab8afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ab8afe"]])

export default __exports__